var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.spinner.show
    ? _c("div", { staticClass: "main-holder" }, [
        _c(
          "div",
          {
            staticClass: "spinner-border white spinner-lg spinner-centered",
            attrs: { role: "status" },
          },
          [
            _c("span", { staticClass: "sr-only" }, [
              _vm._v(_vm._s(_vm.$t("components.spinner.loading"))),
            ]),
          ]
        ),
        _vm.spinner.message
          ? _c("p", {
              staticClass: "preloader-text",
              domProps: {
                innerHTML: _vm._s(_vm.$t("components.spinner.message")),
              },
            })
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }